import allowed from '@/core/constants/allowed-roles.constant'

const routes = [
  {
    name: 'massive-import',
    path: '/massive-import',
    meta: {
      requiresAuth: true,
      layout: 'home',
      module: 'massive-import',
      allowedRoles: [...allowed.massive_import.roles],
      breadcrumb: {
        label: 'massive-import.title',
        route: 'massive-import-log',
      },
    },
    redirect: { name: 'massive-import-new' },
    children: [
      {
        name: 'massive-import-new',
        path: 'new-import',
        component: () =>
          import('@/modules/massive-import/containers/new-import/new-import.container.vue'),
        meta: {
          breadcrumb: {
            label: 'massive-import.new-import.title',
            route: 'massive-import-new',
          },
        },
      },
      {
        name: 'massive-import-log',
        path: 'ingestion-log',
        component: () =>
          import('@/modules/massive-import/containers/ingestion-log/ingestion-log.container.vue'),
        meta: {
          breadcrumb: {
            label: 'massive-import.ingestion-log.title',
            route: 'massive-import-log',
          },
        },
      },
      {
        name: 'massive-import-log-detail',
        path: 'ingestion-log/:importId',
        component: () =>
          import(
            '@/modules/massive-import/containers/ingestion-log-detail/ingestion-log-detail.container.vue'
          ),
        meta: {
          breadcrumb: {
            label: 'massive-import.ingestion-log.detail-title',
            route: 'massive-import-log-detail',
          },
        },
      },
      {
        name: 'massive-import-destinations',
        path: 'destinations',
        component: () =>
          import('@/modules/massive-import/containers/destinations/destinations.container.vue'),
        meta: {
          allowedRoles: [...allowed.massive_import.destinations],
          breadcrumb: {
            label: 'massive-import.destinations.title',
            route: 'massive-import-destinations',
          },
        },
      },
      {
        name: 'massive-import-destination-edit',
        path: 'destinations/:destinationId',
        component: () =>
          import(
            '@/modules/massive-import/containers/destination-edit/destination-edit.container.vue'
          ),
        meta: {
          allowedRoles: [...allowed.massive_import.destinations],
          breadcrumb: {
            label: 'massive-import.destinations.edit-title',
            route: 'massive-import-destination-edit',
          },
        },
      },
    ],
  },
]

export default routes
